import React, { useState, useRef, useEffect } from "react";
import { getData, postData } from '../../../../../ApiServices/ApiService';
import { ORG_CONFIGURATION_ACTIVITY_REGISTER, ORG_GET_CONFIGURATION_CONTACTS_LIST, ORG_GET_EMPLOYEE_LIST} from '../../../../../ApiServices/BaseURL';
import { logFrontendException } from '../../../../../Utils/Exception';
import { useTheme } from '../../../../../GlobalContext/GlobalContext';


const ActivityRegisterController = () => {
    const [whatsAppLogLoading, setwhatsAppLogLoading] = useState(false);
    const [whatsAppLogError, setwhatsAppLogError] = useState('');
    const [whatsAppLogList, setwhatsAppLogList] = useState([]);
    const [emailLogLoading, setEmailLogLoading] = useState(false);
    const [emailLogError, setEmailLogError] = useState('');
    const [emailLogList, setEmailLogList] = useState([]);
    const [smsLogLoading, setSmsLogLoading] = useState(false);
    const [smsLogError, setSmsLogError] = useState('');
    const [smsLogList, setSmsLogList] = useState([]);
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    const { setIsLoginPopup } = useTheme();
    const pageName = "ActivityRegisterController";

    const [contactListLoading, setContactListLoading] = useState(false);
    const [contactListError, setContactListError] = useState('');
    const [contactListList, setContactListList] = useState([]);
    const [userLoading, setUserLoading] = useState(false);
    const [userError, setUserError] = useState('');
    const [recipientOptions, setRecipientOptions] = useState([]);
    

    const [whatsAppStatus, setWhatsAppStatus] = useState(0);

    useEffect(() => {
        const whatsAppStatus = JSON.parse(localStorage.getItem('whatsAppStatus'));
        setWhatsAppStatus(whatsAppStatus);
        if (whatsAppStatus === 1) {
            fetchWhatsppLogList();
        }
    }, [])

    const tabs = ['Email Logs', 'SMS Logs'];
    if (whatsAppStatus === 1) {
        tabs.unshift('WhatsApp Logs');
    }


useEffect(() => {
    // fetchWhatsppLogList();
    fetchEmailLogList();
    fetchSmsLogList();
    fetchContactList();
    fetchUserList();
}, []);


const fetchWhatsppLogList = async () => {
    try {
      setwhatsAppLogList([])
      setwhatsAppLogLoading(true);
      setwhatsAppLogError('')
      // setCurrentPage(1);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "action_type": "list",
        "channel_name":"whatsapp",
        "sent_to":"",
        "sent_by":0,
        "sent_date":"",
        "client_id":0
       
      }
      const response = await postData(ORG_CONFIGURATION_ACTIVITY_REGISTER, payload);
      const responseData = await response.json();


      if (response.status === 200) {
        if (responseData.status_code === 200) {
          if (responseData.message.toLowerCase() === "success") {
            if (responseData?.dataJ?.length > 0) {
            setwhatsAppLogList(responseData?.dataJ || []);
            // setCurrentPage(1);
            } else {
            setwhatsAppLogError(responseData?.info || "WhatsApp Logs are not available.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "whatsAppLogList", responseData?.info || '');

            }
          } else {
            setwhatsAppLogError(responseData?.info || "Failed to fetch whatsapp logs list.");
            logFrontendException(storedUserId, pageName, "whatsAppLogList", responseData?.info || '');
          }
      } else {
        setwhatsAppLogError(responseData?.info || "Failed to fetch whatsapp logs list.Please try again.");
          logFrontendException(storedUserId, pageName, "whatsAppLogList", responseData || '');
      }
      }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setwhatsAppLogError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        logFrontendException(storedUserId, pageName, "whatsAppLogList-Unauthorized", response || '');
               
      } else {
        setwhatsAppLogError(responseData?.info || "Failed to fetch whatsapp logs list.");
        logFrontendException(storedUserId, pageName, "whatsAppLogList", response || '');
      }
    } catch (err) {
        setwhatsAppLogError("Failed to fetch whatsapp logs list.Please check your internet connection and try again.");
      logFrontendException(storedUserId, pageName, "whatsAppLogList-catch", err || '');
    } finally {
        setwhatsAppLogLoading(false);
    }
  };

const fetchEmailLogList = async () => {
    setEmailLogList([])
    setEmailLogLoading(true);
    setEmailLogError('')
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "action_type": "list",
        "channel_name":"email",
        "sent_to":"",
        "sent_by":0,
        "sent_date":"",
        "client_id":0
       
      }
      const response = await postData(ORG_CONFIGURATION_ACTIVITY_REGISTER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            setEmailLogList(responseData?.dataJ || []);
            // setCurrentPage(1);
          } else {
            setEmailLogError(responseData?.info || "Email Logs are not available.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "EmailLogList", responseData?.info || '');

          }
        } else {
            setEmailLogError(responseData?.info || "Failed to fetch email Log list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "EmailLogList", responseData?.info || '');
        }
      }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setEmailLogError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "EmailLogList", responseData || response || '');
               
        } else {
        setEmailLogError(responseData?.info || "Failed to fetch  email list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "EmailLogList", responseData || response || '');
      }
    } catch (err) {
        setEmailLogError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "EmailLogList-catch", err || '');
    } finally {
      setEmailLogLoading(false);
    }
  };

const fetchSmsLogList = async () => {
    setSmsLogList([])
    setSmsLogLoading(true);
    setSmsLogError('')
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "action_type": "list",
        "channel_name":"sms",
        "sent_to":"",
        "sent_by":0,
        "sent_date":"",
        "client_id":0
       
      }
      const response = await postData(ORG_CONFIGURATION_ACTIVITY_REGISTER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            setSmsLogList(responseData?.dataJ || []);
            // setCurrentPage(1);
          } else {
            setSmsLogError(responseData?.info || "Sms Logs are not available.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "smsLogList", responseData?.info || '');

          }
        } else {
            setSmsLogError(responseData?.info || "Failed to fetch  email list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "smsLogList", responseData?.info || '');
        }
      }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setSmsLogError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "smsLogList", responseData || response || '');
               
        } else {
        setSmsLogError(responseData?.info || "Failed to fetch sms log list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "smsLogList", responseData || response || '');
      }
    } catch (err) {
        setSmsLogError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "smsLogList-catch", err || '');
    } finally {
      setSmsLogLoading(false);
    }
  };  

  const fetchContactList = async () => {
    setContactListList([])
    setContactListLoading(true);
    setContactListError('');
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "action_type": "list_of_contact_lists",
        "emp_id_auth": storedUserInfo?.emp_id,
      }
      const response = await postData(ORG_GET_CONFIGURATION_CONTACTS_LIST, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            // setContactListList(responseData?.dataJ || []);
            const filterData = responseData?.dataJ.map(contact => ({
                label: contact?.list_name,
                value: contact?.list_id
              }));
              setContactListList(filterData || []);
            // setCurrentPage(1);
          } else {
            setContactListError(responseData?.info || "Failed to fetch contact list.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "fetchContactList", responseData || '');

          }
        } else {
          setContactListError(responseData?.info || "Failed to fetch contact list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchContactList", responseData || '');
        }
      }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setContactListError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchContactList", responseData || response || '');
                
        } else {
        setContactListError(responseData?.info || "Failed to fetch  contact list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchContactList", responseData || response || '');
      }
    } catch (err) {
      setContactListError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchContactList-catch", err || '');
    } finally {
      setContactListLoading(false);
    }
  };

  const fetchUserList = async () => {
    try {
      setUserLoading(true);
      setUserError('');

      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_EMPLOYEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const formattedTeams = responseData.dataJ.map(service => ({
                label: service.emp_name,
                value: service.emp_id
              }));
              setRecipientOptions(formattedTeams);
            } else {
              setUserError(responseData?.info || 'Data Not Found');
            }
          } else {
            setUserError(responseData?.info || 'Failed to fetch User data. Please try again.');
          }
        } else {
          setUserError(responseData?.info || 'Failed to fetch User data. Status code error.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setUserError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setUserError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
        setIsLoginPopup(true)
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setUserError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setUserError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setUserError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch User data. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setUserError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setUserError(`Failed to fetch User data. Please check your network connection and try again.`);
      }
    } finally {
      setUserLoading(false);
    }
  }



  return{
        whatsAppLogLoading,
        whatsAppLogError,
        whatsAppLogList,
        setwhatsAppLogLoading,
        setwhatsAppLogError,
        setwhatsAppLogList,
        fetchWhatsppLogList,
        emailLogLoading, 
        setEmailLogLoading,
        emailLogError, 
        setEmailLogError,
        emailLogList, 
        setEmailLogList,
        fetchEmailLogList,
        smsLogLoading, 
        setSmsLogLoading,
        smsLogError, 
        setSmsLogError,
        smsLogList,
        setSmsLogList,
        fetchSmsLogList,
        tabs,
        userLoading,
        userError,
        recipientOptions,
        contactListLoading,
        contactListError,
        contactListList,
    }
} 
  export default ActivityRegisterController